module.exports = __webpack_public_path__ + "img/274-3774e1.png";